export const COVERAGES_ASSIGN_TYPES = {
  SET_ASSIGNED_COVERAGES: "SET_ASSIGNED_COVERAGES",
  SET_STATION_UNITS: "SET_STATION_UNITS",
  SET_NEW_ASSIGNED_COVERAGE: "SET_NEW_ASSIGNED_COVERAGE",

  // new coverage assign
  NEW_ASSIGNATION: "NEW_ASSIGNATION",

  // edit coverage assign
  SET_DELETED_ASSIGNED_COVERAGE: "SET_DELETED_ASSIGNED_COVERAGE",
  DELETE_ASSIGNATION_MODE: "DELETE_ASSIGNATION_MODE",
  SET_SELECTED_ASSIGNATION: "SET_SELECTED_ASSIGNATION",
  EDIT_ASSIGNATION_MODE: "EDIT_ASSIGNATION_MODE",
  SET_EDITED_ASSIGNATION: "SET_EDITED_ASSIGNATION",
  SET_COVERAGES_ASSIGN_FILTERS: "SET_COVERAGES_ASSIGN_FILTERS"
};
